import { styled } from "@mui/material"
import { simpleWidgetCardName, simpleWidgetCardSlots } from "@tm/themes"
import { SimpleCardCard } from "../../../muiStyled/Surfaces/simpleCard"

export const SimpleWidgetCardCard = styled(SimpleCardCard, {
    name: simpleWidgetCardName,
    slot: simpleWidgetCardSlots.card,
    overridesResolver: (_, styles) => styles.card,
})(({ theme }) => ({
    boxShadow: "rgba(0, 0, 0, 0.13) 0px 1px 5px 0px",
    "&:hover": {
        borderColor: theme.palette.primary.main,
    },
    padding: theme.spacing(2),
    height: "100%",
    backgroundSize: "cover",
    display: "flex",
    flexDirection: "column",
    borderRadius: theme.radius?.default || "3px",
    gap: theme.spacing(),
}))
